(function($) {
  Date.prototype.yyyymmdd = function() {
    var mm = this.getMonth() + 1; // getMonth() is zero-based
    var dd = this.getDate();

    return [this.getFullYear(),
            (mm>9 ? '' : '0') + mm,
            (dd>9 ? '' : '0') + dd
           ].join('-');
  };

  function getDate() {
    //document.getElementById("date").valueAsDate = new Date();
    $('#date').val(new Date().yyyymmdd());
  }

  function authenticate() {
    const hologramNumber = $('#hologramNumber').val().toUpperCase();
    if(hologramNumber != "" && (hologramNumber.substring(0,2) == 'FS' || hologramNumber.substring(0,1) == 'W')) { //Funko Slab
      $.ajax({
        url: 'https://2tprmqjtf3.us-east-2.awsapprunner.com/api/certification/'+ hologramNumber,
        type: 'GET',
        success: function(response){
          $('.swau-authentication-submit-form--container').hide();
          if (response.length) {
            var obj = response[0];
            var html = '<img class="successImage" src="https://cdn.shopify.com/s/files/1/0535/6434/2470/files/verified-badge_2x_8d2285e0-900a-4965-ba13-3d98f9ccb228.png?v=1643568603" />';
            html += '<div class="successContainer">';
              html += '<div class="successTopText">CONGRATULATIONS</div>';
              html += '<div class="hologramText">Certification '+ obj.certificationNumber +'</div>';
              html += '<div class="authenticText">is a SWAU encapsulated item!</div>';
              html += '<div class="itemTypeText">Item Type: <span>Funko POP</span></div>';
            html += '</div>';

            var foundPhoto = false;
            for(var i = 0; i < response.length; i++) {
              var record = response[i];
              if(record.photo.includes('http') && !foundPhoto) {
                  html += '<img class="itemImage" src="'+ record.photo +'"/>';
                  foundPhoto = true;
              }
            }
            
            html += '<div class="dividerLine"></div>';
            
            for(var i = 0; i < response.length; i++) {
              obj = response[i];
              html += '<div class="signatureContainer">';
                html += '<div class="signatureTopContainer">';
                  html += '<div class="sigDataContainer greenBg">';
                    html += '<div class="sigDataTopText whiteFaded">Funko Name:</div>';
                    html += '<div class="sigDataBottomText white">'+ obj.funkoName +'</div>';
                  html += '</div>';
                  html += '<div class="sigDataContainer">';
                    html += '<div class="sigDataTopText">Grade:</div>';
                    html += '<div class="sigDataBottomText">'+ obj.overallGrade +'</div>';
                  html += '</div>';
                html += '</div>';
                html += '<div class="signatureBottomContainer">';
                if(obj.funkoExclusive) {
                  html += '<div class="sigDataContainer">';
                      html += '<div class="sigDataTopText">Exclusive:</div>';
                      html += '<div class="sigDataBottomText">'+ obj.funkoExclusive +'</div>';
                    html += '</div>';
                }
                if(obj.funkoRarity) {
                  html += '<div class="sigDataContainer">';
                      html += '<div class="sigDataTopText">Rarity:</div>';
                      html += '<div class="sigDataBottomText">'+ 'LE ' + obj.funkoRarity +'</div>';
                    html += '</div>';
                }
                if(obj.autographName) {
                  html += '<div class="sigDataContainer">';
                      html += '<div class="sigDataTopText">Signed By:</div>';
                      html += '<div class="sigDataBottomText">'+ obj.autographName +'</div>';
                    html += '</div>';
                }
                if(obj.autographGrade) {
                  html += '<div class="sigDataContainer">';
                      html += '<div class="sigDataTopText">Autograph Grade:</div>';
                      html += '<div class="sigDataBottomText">'+ obj.autographGrade +'</div>';
                    html += '</div>';
                }
                  html += '<div class="sigDataContainer">';
                    html += '<div class="sigDataTopText">Encapsulation Date:</div>';
                    html += '<div class="sigDataBottomText">'+ obj.date +'</div>';
                  html += '</div>';
              
                html += '</div>';
              html += '</div>';
              html += '<div class="dividerLine"></div>';
            }
            
            html += '<input type="submit" class="btn verify-another-item-btn" value="Verify Another Item">';
            
            $('.swau-authentication-success--container').html(html);
            $('.swau-authentication-success--container').show();

            $('#swau-authentication-form')[0].reset();
          } else {
            var html = '<div class="failContainer">';
            html += '<img class="failImage" src="https://cdn.shopify.com/s/files/1/0535/6434/2470/files/unverified-badge_2x_3ef471bb-afcd-4f85-acc7-ab7f6c442762.png?v=1643568603" />';
            html += '<div class="failContainer">';
              html += '<div class="failTopText">SORRY</div>';
              html += '<div class="hologramText">Certification '+ hologramNumber +'</div>';
              html += '<div class="authenticText">was not found in our database.</div>';
            html += '</div>';
            html += '<input type="submit" class="btn verify-another-item-btn" value="Verify Another Item">';
            html += '</div>';
            $('.swau-authentication-error--container').html(html);
            $('.swau-authentication-error--container').show();
          }

          $('.swau-authentication--container').addClass('loaded');
        }
      });
    }
    else if (hologramNumber != "") {
      $.ajax({
        url: 'https://isbzpdvjqf.us-east-2.awsapprunner.com/api/hologram/'+hologramNumber,
        type: 'GET',
        success: function(response){
          $('.swau-authentication-submit-form--container').hide();
          if (response.length) {
            var obj = response[0];
            var html = '<img class="successImage" src="https://cdn.shopify.com/s/files/1/0535/6434/2470/files/verified-badge_2x_8d2285e0-900a-4965-ba13-3d98f9ccb228.png?v=1643568603" />';
            html += '<div class="successContainer">';
              html += '<div class="successTopText">CONGRATULATIONS</div>';
              html += '<div class="hologramText">Hologram '+ obj.hologramNumber +'</div>';
              html += '<div class="authenticText">is a SWAU authenticated item!</div>';
              html += '<div class="itemTypeText">Item Type: <span>'+ obj.type +'</span></div>';
            html += '</div>';

            var foundPhoto = false;
            for(var i = 0; i < response.length; i++) {
              var record = response[i];
              if(record.photo.includes('http') && !foundPhoto) {
                  html += '<img class="itemImage" src="'+ record.photo +'"/>';
                  foundPhoto = true;
              }
            }
            
            html += '<div class="dividerLine"></div>';
            
            for(var i = 0; i < response.length; i++) {
              obj = response[i];
              html += '<div class="signatureContainer">';
                html += '<div class="signatureTopContainer">';
                  html += '<div class="sigDataContainer greenBg">';
                    html += '<div class="sigDataTopText whiteFaded">Autograph:</div>';
                    html += '<div class="sigDataBottomText white">'+ obj.name +'</div>';
                  html += '</div>';
                  html += '<div class="sigDataContainer">';
                    html += '<div class="sigDataTopText">Date:</div>';
                    html += '<div class="sigDataBottomText">'+ obj.date +'</div>';
                  html += '</div>';
                html += '</div>';
                html += '<div class="signatureBottomContainer">';
                if(obj.personalization) {
                  html += '<div class="sigDataContainer">';
                      html += '<div class="sigDataTopText">Personalization:</div>';
                      html += '<div class="sigDataBottomText">'+ obj.personalization +'</div>';
                    html += '</div>';
                }
                if(obj.characterName) {
                  html += '<div class="sigDataContainer">';
                      html += '<div class="sigDataTopText">Character Name:</div>';
                      html += '<div class="sigDataBottomText">'+ obj.characterName +'</div>';
                    html += '</div>';
                }
                if(obj.quote) {
                  html += '<div class="sigDataContainer">';
                      html += '<div class="sigDataTopText">Quote:</div>';
                      html += '<div class="sigDataBottomText">'+ obj.quote +'</div>';
                    html += '</div>';
                }
                  html += '<div class="sigDataContainer">';
                    html += '<div class="sigDataTopText">Location:</div>';
                    html += '<div class="sigDataBottomText">'+ obj.location +'</div>';
                  html += '</div>';
              
                html += '</div>';
              html += '</div>';
              html += '<div class="dividerLine"></div>';
            }
            
            html += '<input type="submit" class="btn verify-another-item-btn" value="Verify Another Item">';
            
            /*
            html += '<label class="success"><i class="fas fa-check-circle"></i>&nbsp;&nbsp;Congratulations, hologram '+obj.hologramNumber+' is a SWAU authenticated item!</label>';

            html += '<div class="swau-item--container">';

            for(var i=0; i<response.length; i++) {
              obj = response[i];

              html += '<div class="swau-item-info--container">';
              html += '<div class="dividerLine"></div>';
              if (obj.photo){
                html += '<img src="'+obj.photo+'">';
              }
              html += '<span class="item-type strong">Item Type: '+obj.type+'</span>';
              html += '<span class="autograph-information strong">Autograph Information</span>';
              html += '<span class="signer-name strong">'+obj.name+'</span>';
              html += '<span class="date">Autograph Date: '+obj.date+'</span>';
              html += '<span class="location">Autograph Location: '+obj.location+'</span>';
              html += '</div>';
            }

            html += '</div></div>';
            html += '<input type="button" class="btn verify-another-item-btn" value="Verify Another Item">';
			*/
            
            $('.swau-authentication-success--container').html(html);
            $('.swau-authentication-success--container').show();

            $('#swau-authentication-form')[0].reset();
          } else {
            var html = '<div class="failContainer">';
            html += '<img class="failImage" src="https://cdn.shopify.com/s/files/1/0535/6434/2470/files/unverified-badge_2x_3ef471bb-afcd-4f85-acc7-ab7f6c442762.png?v=1643568603" />';
            html += '<div class="failContainer">';
              html += '<div class="failTopText">SORRY</div>';
              html += '<div class="hologramText">Hologram '+ hologramNumber +'</div>';
              html += '<div class="authenticText">was not found in our database.</div>';
            html += '</div>';
            html += '<input type="submit" class="btn verify-another-item-btn" value="Verify Another Item">';
            html += '</div>';
            $('.swau-authentication-error--container').html(html);
            $('.swau-authentication-error--container').show();
          }

          $('.swau-authentication--container').addClass('loaded');
        }
      });
    } else {
      $('.swau-authentication--container').addClass('loaded');
    }
  }
  
  function checkPosted() {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    if (urlParams.has('id')) {
      const hologramNumber = urlParams.get('id');
      $('#hologramNumber').val(hologramNumber);
    } else {
    	$('.swau-authentication--container').addClass('loaded');
    }
  }

  $(document).on('click', '.verify-another-item-btn', function(){
    $('.swau-authentication-success--container').hide();
    $('.swau-authentication-error--container').hide();
    $('.swau-authentication-submit-form--container').show();
  });

//   function onSubmit(token) {
//     $('#swau-authentication-form').submit();
//   }


  $(document).on('submit', '#swau-authentication-form', function(e){
    e.preventDefault();
    $('#swau-authentication-form .error').hide();

    var hologramNumber = $('#hologramNumber').val();

    if ( hologramNumber=='' ) {
      $('#swau-authentication-form .error').show();
      $('html, body').animate({
        scrollTop:$('#swau-authentication-form .error').offset().top
      }, 300);
      return false;
    }
    if($("#g-recaptcha-response").val() == "") {
      $('#swau-authentication-form .error').text("Please verify reCAPTCHA").show();
      return false;
    }
    
    authenticate();

    // grecaptcha.enterprise.ready(function() {
    //   grecaptcha.enterprise.execute('6LedePodAAAAAJvK_EQAbq4ideY-czL2i4nYuFyZ', {action: 'login'}).then(function(token) {

    //     $.ajax({
    //       url: 'https://isbzpdvjqf.us-east-2.awsapprunner.com/api/user/'+hologramNumber,
    //       type: 'GET',
    //       success: function(response){
    //         $('.swau-authentication-submit-form--container').hide();
    //         if (response.length) {
    //           var obj = response[0];
    //           var html = '<label class="success"><i class="fas fa-check-circle"></i>&nbsp;&nbsp;Congratulations, hologram '+obj.hologramNumber+' is an authentic SWAU witnessed item!</label>';

    //           html += '<div class="swau-item--container">';

    //           for(var i=0; i<response.length; i++) {
    //             obj = response[i];

    //             html += '<div class="swau-item-info--container">';
    //             if (obj.photo){
    //               html += '<img src="'+obj.photo+'">';
    //             }
    //             html += '<span class="item-type strong">Item Type: '+obj.type+'</span>';
    //             html += '<span class="autograph-information strong">Autograph Information</span>';
    //             html += '<span class="signer-name strong">'+obj.name+'</span>';
    //             html += '<span class="date">Autograph Date: '+obj.date+'</span>';
    //             html += '<span class="location">Autograph Location: '+obj.location+'</span>';
    //             html += '</div>';
    //           }

    //           html += '</div></div>';
    //           html += '<input type="button" class="verify-another-item-btn" value="Verify Another Item">';

    //           $('.swau-authentication-success--container').html(html);
    //           $('.swau-authentication-success--container').show();

    //           $('#swau-authentication-form')[0].reset();
    //         } else {
    //           var html = '<i class="fas fa-times-circle"></i>&nbsp;&nbsp;Sorry, the hologram '+hologramNumber+' was not found in our database.';
    //           $('.swau-authentication-error--container .error').html(html);
    //           $('.swau-authentication-error--container .error').show();
    //           $('.swau-authentication-error--container').show();
    //         }
    //       },
    //     });
    //   });
    // });


    return true;
  });

  $(document).on('click', '.delete', function(e){
    e.preventDefault();
    if (!$('.internal-staff-update-form--container').hasClass('hidden')) {
      alert( 'Please update the above hologram, first.');
      $('html, body').animate({
        scrollTop:$('.internal-staff-update-form--container').offset().top
      }, 300);
      return false;
    }
    if ( !confirm('Do you want to delete the hologram?') ) {
      return false;
    }

    $(this).closest('tr').remove();

    if (!$('.internal-staff-list table tbody tr').length) {
      $('.internal-staff-list--container').hide();
    }
  });

  $(document).on('click', '.update', function(e){
    e.preventDefault();

    if (!$('.internal-staff-update-form--container').hasClass('hidden')) {
      alert( 'Please update the above hologram, first.');
      $('html, body').animate({
        scrollTop:$('.internal-staff-update-form--container').offset().top
      }, 300);
      return false;
    }

    $('#internal-staff-update-form #index').val( $(this).closest('tr').index() );
    $('#internal-staff-update-form #update_hologramNumber').val( $(this).data('hologramnumber') );
    $('#internal-staff-update-form #update_name').val( $(this).data('name') );
    $('#internal-staff-update-form #update_personalization').val( $(this).data('personalization') );
    $('#internal-staff-update-form #update_characterName').val( $(this).data('characterName') );
    $('#internal-staff-update-form #update_quote').val( $(this).data('quote') );
    $('#internal-staff-update-form #update_date').val( $(this).data('date') );
    $('#internal-staff-update-form #update_location').val( $(this).data('location') );
    $('#internal-staff-update-form #update_type').val( $(this).data('type') );

    $('.internal-staff-submit-form--container').addClass('hidden');
    $('.internal-staff-update-form--container').removeClass('hidden');
    $('.internal-staff--container .error').hide();

    $('html, body').animate({
      scrollTop:$('.internal-staff-update-form--container').offset().top
    }, 300);

  });

  $(document).on('click', '.add-another-record', function(e){
    $('.internal-staff-list table tbody').html('');
    $('.internal-staff-list--container').hide();
    $('html, body').animate({
      scrollTop:$('.internal-staff-submit-form--container').offset().top
    }, 300);
  });

  $(document).on('click', '.commit', function(e){
    var objArr = new Array();
    $('.internal-staff-list table tbody tr').each(function(){
      $(this).find('.update').data('hologramnumber');
      var obj = {};
      obj.hologramNumber = $(this).find('.update').data('hologramnumber');;
      obj.name = $(this).find('.update').data('name');
      obj.personalization = $(this).find('.update').data('personalization');
      obj.characterName = $(this).find('.update').data('charactername');
      obj.quote = $(this).find('.update').data('quote');
      obj.date = $(this).find('.update').data('date');
      obj.location = $(this).find('.update').data('location');
      obj.type = $(this).find('.update').data('type');
      obj.photo = $(this).find('.update').data('photo');
      objArr.push(obj);
    });
    
    $.ajax({
      url: 'https://isbzpdvjqf.us-east-2.awsapprunner.com/api/bulk_json_upload',
      type: 'POST',
      data: {data: JSON.stringify(objArr)},
      success: function(response){
        alert('Committed successfully!');
        $('.internal-staff-list table tbody').html('');
        $('.internal-staff-list--container').hide();
      },
    });
  });

  $('#internal-staff-update-form').on('submit', function(){
    $('.internal-staff--container .error').hide();

    var update_id = $('#index').val(),
        hologramNumber = $('#update_hologramNumber').val(),
        name = $('#update_name').val(),
        personalization = $('#update_personalization').val(),
        characterName = $('#update_characterName').val(),
        quote = $('#update_quote').val(),
        date = $('#update_date').val(),
        location = $('#update_location').val(),
        type = $('#update_type').val(),
        photo = $('#update_photo')[0].files;

    if ( hologramNumber=='' || name=='' || date=='' || location=='' || type=='' ) {
      $('.internal-staff--container .error').show();
      $('html, body').animate({
        scrollTop:$('.internal-staff--container .error').offset().top
      }, 300);
      return false;
    }

    var obj = {};
      obj.hologramNumber = hologramNumber;
      obj.name = name;
      obj.personalization = personalization;
      obj.characterName = characterName;
      obj.quote = quote;
      obj.date = date;
      obj.location = location;
      obj.type = type;
      obj.photo = "";

    if (photo.length) {
      var fd = new FormData();
      fd.append('photo', photo[0]);

      $.ajax({
        url: 'https://isbzpdvjqf.us-east-2.awsapprunner.com/api/upload_image',
        type: 'POST',
        data: fd,
        contentType: false,
        processData: false,
        success: function(response){
          obj.photo = response.photo;
          var html = getTrHtml(obj);
          $(html).insertAfter($('.internal-staff-list table tbody tr').eq(update_id));
          $('.internal-staff-list table tbody tr').eq(update_id).remove();
          $('#internal-staff-update-form')[0].reset();
          $('.internal-staff-update-form--container').addClass('hidden');
          $('.internal-staff-submit-form--container').removeClass('hidden');
        },
      });

    } else {
      var html = getTrHtml(obj);
      $(html).insertAfter($('.internal-staff-list table tbody tr').eq(update_id));
      $('.internal-staff-list table tbody tr').eq(update_id).remove();
      $('#internal-staff-update-form')[0].reset();
      $('.internal-staff-update-form--container').addClass('hidden');
      $('.internal-staff-submit-form--container').removeClass('hidden');
    }


    return false;
  });

  $(document).on('click', '.cancel', function(e){
    e.preventDefault();

    $('.internal-staff-submit-form--container').show();
    $('.internal-staff-update-form--container').hide();
    $('.internal-staff--container .error').hide();
  });

  function getCsvValuesFromLine(line) {
    var values = line.split(',');
    value = values.map(function(value){
        return value.replace(/\"/g, '');
    });
    return values;
  }

  function getTrHtml(obj) {
    var html = "";
    html += '<tr>';
    html += '<td>'+obj.hologramNumber+'</td>';
    html += '<td>'+obj.name+'</td>';
    html += '<td>'+obj.personalization+'</td>';
    html += '<td>'+obj.characterName+'</td>';
    html += '<td>'+obj.quote+'</td>';
    html += '<td>'+obj.date+'</td>';
    html += '<td>'+obj.location+'</td>';
    html += '<td>'+obj.type+'</td>';
    if (obj.photo) {
      html += '<td><img src="'+obj.photo+'"></td>';
    } else {
      html += '<td>N/A</td>';
    }
    html += '<td><a href="#" class="delete"><img src="https://cdn.shopify.com/s/files/1/0535/6434/2470/files/delete.png?v=1641915345" width="64"></a>';
    html += '<a href="#" class="update" data-hologramnumber="'+obj.hologramNumber+'" data-name="'+obj.name+'" data-personalization="'+obj.personalization+'" data-characterName="'+obj.characterName+'"data-date="'+obj.date+'" data-quote="'+obj.quote+'" data-location="'+obj.location+'" data-type="'+obj.type+'" data-photo="'+obj.photo+'"><img src="https://cdn.shopify.com/s/files/1/0535/6434/2470/files/update.png?v=1641915345" width="64"></a>';
    html += '</td>';

    html += '</tr>';

    return html;
  }

  $('#internal-staff-register-form').on('submit', function(){
    $('.internal-staff--container .error').hide();

    var csv_file = $('#csv_file')[0].files;
    if(csv_file.length > 0 ){
      var reader = new FileReader();
      reader.onload = function () {
        var csv_data = reader.result;
        var lines = csv_data.split('\r\n');

        var headers = getCsvValuesFromLine(lines[0]);
        lines.shift(); // remove header line from array

        var infos = lines.map(function(line) {
          var info = {};
          var lineValues = getCsvValuesFromLine(line);

          for (var i = 0; i < lineValues.length; i += 1) {
              info[headers[i]] = lineValues[i];
          }

          return info;
        });

        var html = '';
        for ( let index=0; index<infos.length; index++) {
          let obj = infos[index];

          if ( obj.hologramNumber == "" ){
            continue;
          }

          html += getTrHtml( obj );
        }

        $('.internal-staff-list table tbody').append(html);
        $('.internal-staff-list--container').show();
      };
      // start reading the file. When it is done, calls the onload event defined above.
      reader.readAsBinaryString(csv_file[0]);
    } else {
      var hologramNumber = $('#hologramNumber').val(),
          name = $('#name').val(),
          personalization = $('#personalization').val(),
          characterName = $('#characterName').val(),
          quote = $('#quote').val(),
          date = $('#date').val(),
          location = $('#location').val(),
          type = $('#type').val(),
          photo = $('#photo')[0].files;

      if ( hologramNumber=='' || name=='' || date=='' || location=='' || type=='' ) {
        $('.internal-staff--container .error').show();
        $('html, body').animate({
          scrollTop:$('.internal-staff--container .error').offset().top
        }, 300);
        return false;
      }

      var obj = {};
      obj.hologramNumber = hologramNumber;
      obj.name = name;
      obj.personalization = personalization;
      obj.characterName = characterName;
      obj.quote = quote;
      obj.date = date;
      obj.location = location;
      obj.type = type;
      obj.photo = "";

      if (photo.length) {
        var fd = new FormData();
        fd.append('photo', photo[0]);

        $.ajax({
          url: 'https://isbzpdvjqf.us-east-2.awsapprunner.com/api/upload_image',
          type: 'POST',
          data: fd,
          contentType: false,
          processData: false,
          success: function(response){
            obj.photo = response.photo;
            var html = getTrHtml(obj);
            $('.internal-staff-list table tbody').append(html);
            $('.internal-staff-list--container').show();
          },
        });

      } else {
        var html = getTrHtml(obj);
        $('.internal-staff-list table tbody').append(html);
        $('.internal-staff-list--container').show();
      }
    }

    $('#internal-staff-register-form')[0].reset();
    getDate();

    return false;
  });

  getDate();
  checkPosted();
})(jQuery);